import { parseXml, findChild, findChildren, attrStr, type XmlNode } from './parser.js';

export interface ContentHpfInfo {
  title: string;
  sectionFiles: string[];
  binDataFiles: { id: string; href: string; mediaType: string }[];
}

export function parseContentHpfXml(xml: string): ContentHpfInfo {
  const root = parseXml(xml);

  // metadata
  const metadata = findChild(root, 'opf:metadata');
  const titleNode = metadata ? findChild(metadata, 'opf:title') : undefined;
  const title = titleNode ? titleNode.text : '';

  // manifest → section files
  const manifest = findChild(root, 'opf:manifest');
  const items = manifest ? findChildren(manifest, 'opf:item') : [];

  const sectionFiles: string[] = [];
  const binDataFiles: { id: string; href: string; mediaType: string }[] = [];

  for (const item of items) {
    const id = attrStr(item, 'id');
    const href = attrStr(item, 'href');
    const mediaType = attrStr(item, 'media-type');

    if (id.startsWith('section')) {
      sectionFiles.push(href);
    } else if (id.startsWith('bindata')) {
      binDataFiles.push({ id, href, mediaType });
    }
  }

  // spine에서 순서 가져오기 (fallback)
  if (sectionFiles.length === 0) {
    const spine = findChild(root, 'opf:spine');
    if (spine) {
      for (const itemref of findChildren(spine, 'opf:itemref')) {
        const idref = attrStr(itemref, 'idref');
        if (idref.startsWith('section')) {
          sectionFiles.push(`${idref}.xml`);
        }
      }
    }
  }

  return { title, sectionFiles, binDataFiles };
}
